import * as React from 'react';
import './form-dialog.scss';

class FormDialog extends React.Component<{}, {}> {
  render() {
    const { children } = this.props;
    return <div className="FormDialog">{children}</div>;
  }
}

export default FormDialog;
